import {forwardRef} from 'react';
import {BleskIcon} from '../types';
import {BaseIcon} from './BaseIcon';

export const Image: BleskIcon = forwardRef(function Check(props, ref) {
  return (
    <BaseIcon viewBox="0 0 72 72" {...props} ref={ref}>
      <path
        d="M61.923 46.6166L49.5592 34.2528C48.4331 33.1267 46.6101 33.1267 45.4869 34.2528L33.123 46.6166"
        stroke="currentColor"
        strokeWidth="4.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M53.2859 61.0197H18.7259C13.9538 61.0197 10.0859 57.1518 10.0859 52.3797V17.8197C10.0859 13.0475 13.9538 9.17969 18.7259 9.17969H53.2859C58.0581 9.17969 61.9259 13.0475 61.9259 17.8197V52.3797C61.9259 57.1518 58.0581 61.0197 53.2859 61.0197Z"
        stroke="currentColor"
        strokeWidth="4.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M47.5247 61.0192L29.4008 42.8953C28.2747 41.7693 26.4517 41.7693 25.3285 42.8953L11.3691 56.8547"
        stroke="currentColor"
        strokeWidth="4.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M28.1275 25.6959C28.5493 26.1176 28.5493 26.8014 28.1275 27.2232C27.7057 27.645 27.0219 27.645 26.6002 27.2232C26.1784 26.8014 26.1784 26.1176 26.6002 25.6959C27.0219 25.2741 27.7057 25.2741 28.1275 25.6959"
        stroke="currentColor"
        strokeWidth="4.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </BaseIcon>
  );
});
